export const IFrameData = ({link}) => {    
    return (
        <div className="container-fluid mb-3">
            <div className="row">
                <div className="col-12 col-md-10 col-lg-8">
                <div className="p-4 border rounded bg-white">
                    <iframe
                    src={link}
                    title="Form link"
                    className="w-100 border rounded"
                    height="400"
                    allowFullScreen
                    sandbox
                    />
                </div>
                </div>
            </div>
        </div>
    )
}